import { render, staticRenderFns } from "./FormPermalinkAside.vue?vue&type=template&id=bc612d54&scoped=true&"
import script from "./FormPermalinkAside.vue?vue&type=script&lang=js&"
export * from "./FormPermalinkAside.vue?vue&type=script&lang=js&"
import style0 from "./FormPermalinkAside.vue?vue&type=style&index=0&id=bc612d54&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc612d54",
  null
  
)

export default component.exports